import StateType, { InvoiceConfigurationType } from './state.type';

export default {
  toggleLoading(state: StateType, isLoading: boolean): void {
    state.loading = isLoading;
  },
  toggleLoadingSave(state: StateType, isLoading: boolean): void {
    state.loadingSave = isLoading;
  },
  setInvoiceConfiguration(state: StateType, invoiceConfiguration: InvoiceConfigurationType): void {
    state.invoiceConfiguration = invoiceConfiguration;
  },
  setPreSignedUrlCertificate(state: StateType, preSignedUrlCertificate: string): void {
    state.preSignedUrlCertificate = preSignedUrlCertificate;
  },
  setPreSignedUrlLogo(state: StateType, preSignedUrlLogo: string): void {
    state.preSignedUrlLogo = preSignedUrlLogo;
  },
};
